module.exports = __webpack_public_path__ + "static/touching-down_acrylic-on-recycled-canvas-48x36in-2016-2ca7e2c2c712350555cbe87ae9dec6b8.jpg";